import { render, staticRenderFns } from "./EmailConfigs.vue?vue&type=template&id=31963544&scoped=true"
import script from "./EmailConfigs.vue?vue&type=script&lang=js"
export * from "./EmailConfigs.vue?vue&type=script&lang=js"
import style0 from "./EmailConfigs.vue?vue&type=style&index=0&id=31963544&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31963544",
  null
  
)

export default component.exports